import React from "react";
import BenefitItem from "./ui/BenefitItem";

/**
 * Section highlighting the value proposition of Spot Formations.
 * Includes a "Success vs Old Pain Points" comparison and a "Target Audience" grid.
 */
const BenefitsSection: React.FC = () => {
    return (
        <section className="py-15 overflow-hidden px-4">
            <div className="max-w-232.5 mx-auto">
                <h2 className="font-red-hat text-[30px] sm:text-[40px] text-[#1B515E] leading-9 sm:leading-13.25 font-light text-center mb-6">
                    Ce que Spot Formations vous apporte
                </h2>

                <div className="flex flex-col lg:flex-row justify-between items-start gap-6 mb-10 sm:mb-15">
                    <div className="w-full md:max-w-101.5 lg:mx-0 mx-auto">
                        <div className="bg-[#C7F8FF] rounded-3xl p-5 relative overflow-hidden">
                            <h3 className="font-red-hat font-light text-[24px] sm:text-[30px] leading-8 sm:leading-10 text-[#1B365E] mb-2">Notre solution :</h3>
                            <div className="space-y-1 sm:space-y-3">
                                <BenefitItem text="Une présence professionnelle sur le web" />
                                <BenefitItem text="Des prospects filtrés et motivés" />
                                <BenefitItem text="Un tableau de bord clair pour gérer votre activité" />
                                <BenefitItem text="Des documents prêts à l'emploi" />
                                <BenefitItem text="Un accompagnement personnalisé à votre démarrage" />
                            </div>
                        </div>
                    </div>

                    <div className="w-full md:max-w-106.5 lg:mx-0 mx-auto pt-5">
                        <h3 className="font-red-hat font-light text-[24px] sm:text-[30px] leading-8 sm:leading-10 text-[#1B365E] mb-3 sm:mb-6.5">Ce que vous ne ferez plus :</h3>
                        <div className="space-y-1 sm:space-y-2.5 px-2.5">
                            <BenefitItem text="Créer des pages de vente tout seul" type="error" />
                            <BenefitItem text="Faire de la publicité Facebook/Google à l'aveugle" type="error" />
                            <BenefitItem text="Perdre du temps à convaincre des prospects non qualifiés" type="error" />
                            <BenefitItem text="Gérer mille fichiers et tableurs for le suivi de vos sessions" type="error" />
                        </div>
                    </div>
                </div>

                {/* Target audience subsection */}
                <div className="max-w-160 mx-auto">
                    <h2 className="font-red-hat text-[30px] sm:text-[40px] text-[#1B515E] leading-9 sm:leading-13.25 font-light text-center mb-4 sm:mb-6.5">
                        À qui s&apos;adresse cette opportunité ?
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 space-y-0 sm:gap-y-5 gap-x-8">
                        <BenefitItem text="Formateurs indépendants certifiés ou en cours de certification" type="warning" />
                        <BenefitItem text="Consultants-formateurs" type="warning" />
                        <BenefitItem text="Coachs" type="warning" />
                        <BenefitItem text="Mentors" type="warning" />
                        <BenefitItem text="Anciens salariés ou freelances souhaitant transmettre leur savoir" type="warning" />
                        <BenefitItem text="Toute personne disposant d'une réelle expertise et d'une pédagogie claire" type="warning" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BenefitsSection;
